import Vue from 'vue'
import Vuex from 'vuex'
import { rubyIdentModule } from '@/modules/ruby-ident.module';
import { alertModule } from "@/modules/alert.module";
import { cliffMarketModule } from "@/modules/cliff-market.module";
import { interactiveLinkModule } from "@/modules/interactive-link.module";
import { keyNaveModule } from "@/modules/key-nave.module";
import { prismPeakModule } from "@/modules/prism-peak.module";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sidebarOpen: false,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    rubyIdent: rubyIdentModule,
    alert: alertModule,
    cliffMarket: cliffMarketModule,
    interactiveLink: interactiveLinkModule,
    keyNave: keyNaveModule,
    prismPeak: prismPeakModule
  }
})
